import * as React from 'react';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

import { cn } from 'src/lib/utils';

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

/**
 * Styled to match the shared HireEdge `.tip` design token:
 * surface bg, 1px border, 10px radius, shadow-pop, 11px/13px padding,
 * 12.5px/1.55 body text. Pass `name` to render the uppercase brand
 * "head" label (dot + name) above the body content.
 */
const TooltipContent = React.forwardRef(
  (
    {
      className,
      sideOffset = 6,
      name,
      children,
      // Lets a caller override the arrow's own fill to match a recolored
      // tooltip body (e.g. a dark inverse tooltip via bg-foreground) —
      // `className` only reaches this content box, not the Arrow svg, which
      // otherwise stays the default popover color regardless.
      arrowClassName,
      ...props
    },
    ref
  ) => (
    <TooltipPrimitive.Content
      ref={ref}
      sideOffset={sideOffset}
      className={cn(
        'z-50 max-w-[320px] rounded-[10px] border border-border bg-popover px-[13px] py-[11px] text-[12.5px] leading-[1.55] text-muted-foreground shadow-pop animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
        className
      )}
      {...props}
    >
      {name ? (
        <>
          <div className="mb-[5px] flex items-center gap-[7px]">
            <span className="h-[5px] w-[5px] flex-shrink-0 rounded-full bg-primary" />
            <span className="text-[11px] font-[650] uppercase tracking-[0.04em] text-primary">
              {name}
            </span>
          </div>
          <div className="text-[12.5px] leading-[1.55] text-muted-foreground">
            {children}
          </div>
        </>
      ) : (
        children
      )}
      <TooltipPrimitive.Arrow
        width={11}
        height={6}
        className={cn(
          'fill-popover [clip-path:inset(0_-6px_-6px_-6px)] drop-shadow-[0_1px_0_hsl(var(--border))]',
          arrowClassName
        )}
      />
    </TooltipPrimitive.Content>
  )
);
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
